export const WISHLIST_PERSISTENT_MEMORY_VERSION = 1;
export const WISHLIST_PERSISTENT_MEMORY_KEY_PREFIX = 'nexus:wishlists:persistent-memory';
export const WISHLIST_PERSISTENT_MEMORY_DB_NAME = 'nexus-wishlists-persistent-memory';
export const WISHLIST_PERSISTENT_MEMORY_STORE_NAME = 'wishlist-memory';
